import React, { useState } from 'react';
import BankModalView from '../../../../banks/bankModalView';
import type { Bank } from '../../../../../../common/models/banks/bank';
import type { BankBranch } from '../../../../../../common/models/banks/bankBranch';

interface Props {
  bank: Bank | null;
  branch: BankBranch | null;
  errors: {
    bank_id?: string[];
    bank_branch_id?: string[];
  };
}

export default function BankView({
  bank: initialBank,
  branch: initialBranch,
  errors,
}: Props) {
  const [bank, setBank] = useState<Bank | null>(initialBank);
  const [branch, setBranch] = useState<BankBranch | null>(initialBranch);
  const [hideError, setHideError] = useState<boolean>(false);

  const hasError = () => {
    if (hideError) {
      return false;
    } else {
      return (
        (errors.bank_id != null && errors.bank_id.length > 0) ||
        (errors.bank_branch_id != null && errors.bank_branch_id.length > 0)
      );
    }
  };

  const onOk = () => {
    setHideError(true);
    $('#bank_modal').modal('hide');
  };

  const onCancel = () => {
    setBank(null);
    setBranch(null);
    $('#bank_modal').modal('hide');
  };

  return (
    <div>
      <div
        className={
          hasError()
            ? 'customer-info-group customer-info-bank has-error'
            : 'customer-info-group customer-info-bank'
        }
      >
        <div className="col-form-label">
          <label className="col-form-label-ttl">金融機関・支店</label>
        </div>

        <div className="form-group-inner">
          <div className="customer-info-group-input input-bank">
            {(bank || branch) && (
              <div className="customer-info-group-bank">
                {bank && <span className="mr-10">{bank.name}</span>}
                {branch && <span>{branch.name}</span>}
              </div>
            )}
            <button
              type="button"
              className={
                'btn btn-lg btn-flat btn-primary-outline-gray ' +
                (bank && branch ? 'bank-btn-checked' : '')
              }
              data-toggle="modal"
              data-target="#bank_modal"
            >
              {bank && branch ? '再選択' : '金融機関・支店を選択'}
            </button>
            <input
              value={bank ? bank.id : ''}
              type="hidden"
              name="user[bank_id]"
            />
            <input
              value={branch ? branch.id : ''}
              type="hidden"
              name="user[bank_branch_id]"
            />
          </div>
          {hasError() && (
            <label className="validation-error error">
              金融機関・支店を選択してください
            </label>
          )}
        </div>
      </div>

      <BankModalView
        bank={bank}
        branch={branch}
        onChangeBank={selectedBank => setBank(selectedBank)}
        onChangeBranch={selectedBranch => setBranch(selectedBranch)}
        onOk={onOk}
        onCancel={onCancel}
      />
    </div>
  );
}
